/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
export const ServicesEnum = {
    PUT_SERVICE_RELOAD: (service: string): string => {
        return `/services/${service}/reload`;
    },
    PUT_SERVICE_RESTART: (service: string): string => {
        return `/services/${service}/restart`;
    },
    GET_SERVICES_STATUS: '/services',
    PUT_SERVICES_APPLY: '/services/apply',
};
